import { $, $$, setBusy } from './lib.js';

/** Reading progress and step highlighting in the lesson player. */
export function initPlayer() {
  const player = $('[data-lesson-player]');
  if (!player) return;

  const bar = $('[data-reading-progress]');
  const update = () => {
    const rect = player.getBoundingClientRect();
    const total = rect.height - window.innerHeight;
    const pct = total > 0 ? Math.min(100, Math.max(0, (-rect.top / total) * 100)) : 100;
    if (bar) bar.style.width = `${pct}%`;
  };
  document.addEventListener('scroll', update, { passive: true });
  update();

  const links = new Map($$('[data-step-link]').map((a) => [a.getAttribute('href').slice(1), a]));
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        links.forEach((link) => {
          link.classList.remove('bg-wash', 'text-ink', 'font-medium');
          link.removeAttribute('aria-current');
        });
        const active = links.get(entry.target.id);
        if (active) {
          active.classList.add('bg-wash', 'text-ink', 'font-medium');
          active.setAttribute('aria-current', 'step');
          active.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      });
    },
    { rootMargin: '-40% 0px -55% 0px' },
  );
  $$('[data-player-section]').forEach((s) => observer.observe(s));
}

/** Quiz: warn about unanswered questions once, and prevent double submission. */
export function initQuiz() {
  const form = $('[data-quiz-form]');
  if (!form) return;
  let warned = false;

  form.addEventListener('submit', (event) => {
    const unanswered = $$('[data-question]', form).filter((q) => {
      const text = q.querySelector('input[type="text"], input:not([type])');
      if (text) return text.value.trim() === '';
      return !q.querySelector('input[type="radio"]:checked');
    });

    const note = $('[data-unanswered]', form);
    if (unanswered.length && !warned) {
      event.preventDefault();
      warned = true;
      note.textContent = `${unanswered.length} question${unanswered.length > 1 ? 's are' : ' is'} unanswered. Submit anyway, or go back and answer ${unanswered.length > 1 ? 'them' : 'it'}.`;
      note.classList.remove('hidden');
      unanswered[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
      unanswered[0].querySelector('input')?.focus({ preventScroll: true });
      return;
    }
    setBusy(form.querySelector('button[type="submit"]'), true, 'Checking answers…');
  });
}
